import React from 'react';
import styled from 'styled-components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useSpecialMenuCards from 'src/dispensary/hooks/use-special-menu-cards';
import { useHideSalesLanguage } from 'src/hooks/use-hide-sales-language';

import { OfferMenuSectionV2 } from 'components/offer-menu-section';
import ContentWrapper from 'components/core/content-wrapper';
import { SpecialsFilterChips } from 'components/specials-filter-chips';
import { SpecialsCategoryGrid } from 'components/specials-category-cards/specials-category-grid';
import { useRemoteComponent, RemoteComponentSlot } from 'hooks/use-remote-component';
import { BreadCrumbs } from 'src/components/bread-crumbs';
import { useIsMobile } from 'src/hooks/use-is-mobile';
import useUI from 'src/hooks/use-ui';

export function SpecialsPageContentV2(): JSX.Element | null {
  const { dispensary } = useDispensary();
  const hideSalesLanguage = useHideSalesLanguage();
  const isMobile = useIsMobile();
  const { isDutchieMain } = useUI();

  const ListPageHero = useRemoteComponent(RemoteComponentSlot.ListPageHero);

  const { specials, loading: specialsLoading } = useSpecialMenuCards({
    skip: !dispensary,
  });

  if (!dispensary) {
    return null;
  }

  // "Specials" is restricted under some state regulations (e.g. MA);
  // useHideSalesLanguage swaps it for compliant copy.
  const pageTitle = hideSalesLanguage ? 'All Offers' : 'All Specials';

  return (
    <>
      <ListPageHero />
      <Container $isDutchieMain={isDutchieMain}>
        {isDutchieMain && (
          <BreadCrumbsContainer $isMobile={isMobile}>
            <BreadCrumbs includeLeftPadding={false} />
          </BreadCrumbsContainer>
        )}
        <SpecialsCategoryGrid specials={specials} dispensaryCName={dispensary.cName} loading={specialsLoading} />
        <SpecialsFilterChips />
        <OfferMenuSectionV2
          dispensary={dispensary}
          specials={specials}
          pageTitle={pageTitle}
          loading={specialsLoading}
        />
      </Container>
    </>
  );
}

const Container = styled(ContentWrapper)<{ $isDutchieMain: boolean }>`
  margin-top: ${({ $isDutchieMain }) => ($isDutchieMain ? '0' : '48px')};
`;

const BreadCrumbsContainer = styled.div`
  padding: 24px 16px;
`;
